import { FC } from 'react';

import { useCAForCard } from 'shared/hooks/useCAForCard';
import { IAreaPartsSchema } from 'shared/repositories/commercial-search-offers/entities/area_parts/AreaPartsSchema';
import { useListingLayoutIsShortSelector } from 'shared/store/clientSide/slices/listingLayout';
import { stopPropagation } from 'shared/utils/event/stopPropagation';
import { extractUndefined } from 'shared/utils/extractUndefined';

import { AreaParts } from './AreaParts';

type AreaPartsContainerProps = {
  areaParts: IAreaPartsSchema;
};

export const AreaPartsContainer: FC<AreaPartsContainerProps> = props => {
  const { areaParts } = props;

  const caForCard = useCAForCard();
  const isMapOpen = useListingLayoutIsShortSelector();

  const trackAreaPartClick = (): void => {
    caForCard({ action: 'click_sopr', category: 'Listing', label: 'to_card_areas' });
  };

  const trackMoreClick = (): void => {
    caForCard({ action: 'click_sopr', category: 'Listing', label: 'to_card_more_areas' });
  };

  return (
    <AreaParts
      isMapOpen={isMapOpen}
      more={extractUndefined(areaParts.more)}
      subareas={areaParts.subareas}
      trackAreaPartClick={trackAreaPartClick}
      trackMoreClick={trackMoreClick}
      onAreaPartClick={stopPropagation}
      onMoreClick={stopPropagation}
    />
  );
};
